import { render, staticRenderFns } from "./experimentDetailView.vue?vue&type=template&id=60625355&scoped=true"
import script from "./experimentDetailView.vue?vue&type=script&lang=js"
export * from "./experimentDetailView.vue?vue&type=script&lang=js"
import style0 from "./experimentDetailView.vue?vue&type=style&index=0&id=60625355&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60625355",
  null
  
)

export default component.exports